import { defineMessages } from 'react-intl';

export const editorMessages = defineMessages({
  title: { defaultMessage: 'Title', id: '9a9+ww' },
  placeholder: { defaultMessage: 'Enter a title for the topic', id: '6J8nFN' },
  bodyTitle: { defaultMessage: 'Content', id: 'Jq3FDz' },
  subjectRequired: { defaultMessage: 'The subject of the page is required', id: 'QkHhyV' },
  minContent: { defaultMessage: 'The content of the page is too short', id: 'km08gl' },
  maxContent: { defaultMessage: 'The content of the page is too long', id: '87sm0v' },
  minSubject: { defaultMessage: 'The topic of the page is too short', id: 'SEXrdP' },
  maxSubject: { defaultMessage: 'The topic of the page is too long', id: 'icrSEy' },
  contentRequired: { defaultMessage: 'You must enter content', id: 'hC9GTt' },
  genericError: {
    defaultMessage:
      'We could not take your changes into account for the following reasons: {error}',
    id: 'TGQqkW',
  },
  // The key is also in a response from the API. Don't change it.
  'maximum file length exceeded': {
    defaultMessage: 'Uploading is reserved for images less than 2 MB',
    id: 'xMq7M5',
  },
  optInNotif: {
    defaultMessage: 'Receive a notification each time someone posts a message on this topic',
    id: 'RswTkI',
  },
  imagesOnly: { defaultMessage: 'Uploading is reserved for images only', id: 'ihv78B' },
  cancel: { defaultMessage: 'Cancel and return to the page', id: 'RrkOVK' },
  send: { defaultMessage: 'Send', id: '9WRlF4' },
  submitConfirmation: {
    defaultMessage: 'Your Topic has been sent, it is currently under moderation.',
    id: 'dIPjDn',
  },
});
